import type { PublicApiKey } from '#packages/apilib';
import type { createMediaServicesApi } from './api';

export const MediaServicesApiKey: PublicApiKey<typeof createMediaServicesApi> =
  {
    name: 'MediaServicesApi',
    public: true,
  };
